import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=0bc265e8&scoped=true"
import script from "./FirstPage.vue?vue&type=script&lang=ts"
export * from "./FirstPage.vue?vue&type=script&lang=ts"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=0bc265e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc265e8",
  null
  
)

export default component.exports